import * as actions from "actions";
import { getSubscriptionDetails, updateSubscription } from "TamtamAPI";
import {
  UpdateReceiveNewsletter,
  updateSubscriptionTT,
} from "../../api/TamtamAPI/subscriptionUA";

export const fetchSubscriptionDetails = (cmail) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;

    return dispatch(
      actions.fetchSubscriptionDetails(getSubscriptionDetails(token, cmail)),
    );
  };
};

export const toggleSubscription = (data) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;

    return dispatch(
      actions.toggleSubscription(updateSubscription(token, data)),
    );
  };
};
export const toggleSubscriptionTT = (data) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;

    return dispatch(
      actions.toggleSubscription(updateSubscriptionTT(token, data)),
    );
  };
};
export const ReSubscribeUser = (recipientId) => {
  return (dispatch, getState) => {
    const { token, currentClient, user } = getState().auth;
    const data = {
      id: recipientId,
      organizationId: currentClient?.id,
      updaterUserId: user?.id,
    };

    return dispatch(
      actions.subscribeUser(UpdateReceiveNewsletter(token, data)),
    );
  };
};
